module.exports = __webpack_public_path__ + "img/advertised.34943869.svg";